import { render, staticRenderFns } from "./AgencyChooseProjectTypeReadOnlyView.vue?vue&type=template&id=2546f52a&scoped=true&"
import script from "./AgencyChooseProjectTypeReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./AgencyChooseProjectTypeReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546f52a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCardText})
